import { gql } from "graphql-request";

export const CREATE_SEASON_MUTATION = gql`
  mutation InsertSeason(
    $name: String!
    $startDate: DateTime
    $endDate: DateTime
    $maxGiveAmt: Int
    $minGiveAmt: Int
    $status: String
    $seasonAllowance: Int
  ) {
    insertseason(
      input: {
        name: $name
        startDate: $startDate
        endDate: $endDate
        maxGiveAmt: $maxGiveAmt
        minGiveAmt: $minGiveAmt
        status: $status
        seasonAllowance: $seasonAllowance
      }
    ) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

// Per-section "Save" on the Configure tab. Sends the full config snapshot
// every time so omitted variables never null-out existing fields.
export const UPDATE_SEASON_CONFIG_MUTATION = gql`
  mutation UpdateSeasonConfig(
    $filter: String!
    $maxGiveAmt: Int
    $minGiveAmt: Int
    $seasonAllowance: Int
    $endDate: DateTime
  ) {
    updateseason(
      filter: $filter
      input: {
        maxGiveAmt: $maxGiveAmt
        minGiveAmt: $minGiveAmt
        seasonAllowance: $seasonAllowance
        endDate: $endDate
      }
    ) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

export const UPDATE_SEASON_MUTATION = gql`
  mutation UpdateSeason(
    $filter: String!
    $status: String
    $endDate: DateTime
  ) {
    updateseason(
      filter: $filter
      input: {
        status: $status
        endDate: $endDate
      }
    ) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

export const GET_CURRENT_ACTIVE_SEASON_QUERY = gql`
  query GetCurrentActiveSeason($orgId: String!) {
    getseasons(
      where: {
        OrganizationIds: { contains: $orgId }
        status: { eq: "active" }
      }
      order: []
      paging: {
        pageNo: 1
        pageSize: 1
      }
    ) {
      items {
        ItemId
        CreatedDate
        LastUpdatedDate
        CreatedBy
        Language
        LastUpdatedBy
        OrganizationIds
        Tags
        name
        startDate
        endDate
        maxGiveAmt
        minGiveAmt
        seasonAllowance
        status
      }
      totalCount
      pageNo
      pageSize
      totalPages
      hasNextPage
      hasPreviousPage
    }
  }
`;


export const GET_ALL_SEASONS_QUERY = gql`
  query GetCurrentActiveSeason($orgId: String!) {
    getseasons(
      where: {
        OrganizationIds: { contains: $orgId }
      }
      order: [{ field: "CreatedDate", direction: DESC }]
      paging: {}
    ) {
      items {
        ItemId
        CreatedDate
        LastUpdatedDate
        CreatedBy
        Language
        LastUpdatedBy
        OrganizationIds
        Tags
        name
        startDate
        endDate
        maxGiveAmt
        minGiveAmt
        status
      }
      totalCount
      pageNo
      pageSize
      totalPages
      hasNextPage
      hasPreviousPage
    }
  }
`;

export const CREATE_USER_STAR_BALANCE_MUTATION = gql`
  mutation InsertUserStarBalance(
    $userId: String!
    $seasonId: String!
    $seasonAllowance: Int!
    $userInfo: usersnapshotInput!
  ) {
    insertuserStarBalance(
      input: {
        userId: $userId
        seasonId: $seasonId
        seasonAllowance: $seasonAllowance
        userInfo: $userInfo
        starsRemaining: $seasonAllowance
      }
    ) {
      acknowledged
      itemId
      totalImpactedData
      message
    }
  }
`;

export const GET_USER_STAR_BALANCE_QUERY = gql`
  query GetUserStarBalance($userId: String!, $seasonId: String!, $orgId: String!) {
    getuserStarBalances(
      where: {
        userId: { eq: $userId }
        seasonId: { eq: $seasonId }
        OrganizationIds: { contains: $orgId }
      }
    ) {
      items {
        ItemId
        userId
        seasonId
        seasonAllowance
        starsRemaining
        userInfo {
          email
          profileImageUrl
          userId
          displayName
          firstName
          lastName
        }
        CreatedDate
        LastUpdatedDate
      }
      totalCount
    }
  }
`;


export const UPDATE_USER_STAR_BALANCE_MUTATION = gql`
  mutation UpdateUserStarBalance(
    $userId: String!,
    $seasonId: String!
    $starsRemaining: Int!
    $orgId: String!
  ) {
    updateuserStarBalance(
      where: {
        userId: { eq: $userId }
        seasonId: { eq: $seasonId }
        OrganizationIds: { contains: $orgId }
      }
      input: {
        starsRemaining: $starsRemaining
      }
    ) {
      acknowledged
      itemId
    }
  }
`;

export const GET_SEASON_STAR_BALANCES_QUERY = gql`
  query GetSeasonStarBalances($seasonId: String!, $orgId: String!) {
    getuserStarBalances(
      where: {
        seasonId: { eq: $seasonId }
        OrganizationIds: { contains: $orgId }
      }
    ) {
      items {
        ItemId
        userId
        seasonId
        seasonAllowance
        starsRemaining
        userInfo {
          email
          profileImageUrl
          userId
          displayName
        }
        CreatedDate
        LastUpdatedDate
      }
      totalCount
    }
  }
`;


export const CREATE_STAR_TRANSACTION_MUTATION = gql`
  mutation InsertStarTransaction(
    $seasonId: String!
    $senderId: String!
    $recipientId: String!
    $senderInfo: usersnapshotInput!
    $recipientInfo: usersnapshotInput!
    $amount: Int!
    $message: String
    $type: String!
  ) {
    insertstarTransaction(
      input: {
        seasonId: $seasonId
        senderId: $senderId
        recipientId: $recipientId
        senderInfo: $senderInfo
        recipientInfo: $recipientInfo
        amount: $amount
        message: $message
        type: $type
      }
    ) {
      acknowledged
      itemId
      totalImpactedData
      message
    }
  }
`;

export const DELETE_STAR_TRANSACTION_MUTATION = gql`
  mutation DeleteStarTransaction($filter: String!) {
    deletestarTransaction(filter: $filter) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

export const GET_STAR_TRANSACTIONS_QUERY = gql`
  query GetStarTransactions(
    $seasonId: String
    $orgId: String!
    $pageNo: Int
    $pageSize: Int
  ) {
    getstarTransactions(
      where: {
        seasonId: { eq: $seasonId }
        OrganizationIds: { contains: $orgId }
      }
      order: [{ field: "CreatedDate", direction: DESC }]
      paging: {
        pageNo: $pageNo
        pageSize: $pageSize
      }
    ) {
      items {
        ItemId
        CreatedDate
        LastUpdatedDate
        CreatedBy
        Language
        LastUpdatedBy
        OrganizationIds
        Tags
        seasonId
        senderId
        senderInfo {
          displayName
          email 
        }
        recipientId
        recipientInfo {
          displayName
          email 
        }
        amount
        message
        type
      }
      totalCount
      pageNo
      pageSize
      totalPages
      hasNextPage
      hasPreviousPage
    }
  }
`;


export const GET_SEASON_STAR_TRANSACTIONS_QUERY = gql`
  query GetStarTransactions(
    $seasonId: String
    $orgId: String!
  ) {
    getstarTransactions(
      where: {
        seasonId: { eq: $seasonId }
        OrganizationIds: { contains: $orgId }
      }
      order: [{ field: "CreatedDate", direction: DESC }]
    ) {
      items {
        ItemId
        CreatedDate
        LastUpdatedDate
        CreatedBy
        Language
        LastUpdatedBy
        OrganizationIds
        Tags
        seasonId
        senderId
        senderInfo {
          displayName
          email 
        }
        recipientId
        recipientInfo {
          displayName
          email 
        }
        amount
        message
        type
      }
      totalCount
    }
  }
`;
